export default {
  sidebar: {
    home: '首页',
    stylegen: '样式生成器',
    help: '帮助',
    plugins: '插件',
    links: '常用链接',
    projectAddress: '项目地址',
    discussion: '反馈 / 交流',
    documentation: '文档',
    mall: 'B站商店',
    giftRecordOfficial: '付费记录',
  },
  home: {
    roomIdEmpty: '房间ID不能为空',
    roomIdInteger: '房间ID必须为正整数',
    authCodeEmpty: '身份码不能为空',
    authCodeFormatError: '身份码格式错误',

    unavailableWhenUsingAuthCode: '已废弃，使用身份码时不可用',
    disabledByServer: '已被服务器禁用',

    general: '常规',
    useAuthCodeWarning: '请优先使用身份码，否则无法显示昵称，且随时可能无法获取弹幕',
    room: '房间',
    roomId: '房间ID（不推荐）',
    authCode: '身份码',
    howToGetAuthCode: '如何获取身份码',
    showDanmaku: '显示弹幕',
    showGift: '显示付费消息',
    showGiftName: '显示礼物名',
    mergeSimilarDanmaku: '合并相似弹幕',
    mergeGift: '合并礼物',
    minGiftPrice: '最低显示付费消息价格（元）',
    maxNumber: '最多显示消息数',

    block: '屏蔽',
    giftDanmaku: '屏蔽抽奖弹幕',
    mirrorMessage: '屏蔽跨房弹幕',
    blockLevel: '屏蔽用户等级低于',
    informalUser: '屏蔽非正式会员',
    unverifiedUser: '屏蔽未绑定手机用户',
    blockKeywords: '屏蔽关键词',
    onePerLine: '一行一个',
    blockUsers: '屏蔽用户',
    blockMedalLevel: '屏蔽当前直播间勋章等级低于',

    advanced: '高级',
    showDebugMessages: '显示调试消息',
    showDebugMessagesTip: '消息无法显示时可开启排查，正常使用时无需开启',
    relayMessagesByServer: '通过服务器转发消息',
    relayMessagesByServerTip: '开启后消息路径：B站服务器 → blivechat服务器 → 你的浏览器。部分高级功能依赖此选项。建议仅在本地使用时开启，通过远程服务器使用时不开启',
    autoTranslate: '自动翻译消息为日语',
    requiresRelayMessagesByServer: '需要通过服务器转发消息',
    giftUsernamePronunciation: '标注付费用户名读音',
    dontShow: '不显示',
    pinyin: '拼音',
    kana: '日文假名',
    importPresetCss: '导入服务器预设CSS',
    importPresetCssTip: '自动使用服务器预设的CSS文件“data/custom_public/preset.css”，而无需修改OBS中的自定义CSS',

    emoticon: '自定义表情',
    emoticonKeyword: '替换关键词',
    emoticonUrl: 'URL',
    operation: '操作',
    addEmoticon: '添加表情',
    emoticonFileTooLarge: '文件尺寸太大，最大1MB',

    template: '自定义HTML模板',
    templateHelp: '帮助',
    templateHelpContent: `\
<p>自定义HTML模板可以完全自定义房间页面，包括DOM结构和CSS样式。模板可能由第三方作者开发，其安全性和质量由模板作者负责。
  你可以在<a target="_blank" href="https://github.com/xfgryujk/blivechat/discussions/categories/%E8%87%AA%E5%AE%9A%E4%B9%89html%E6%A8%A1%E6%9D%BF"
  >GitHub Discussions</a>获取已发布的模板</p>
<p>模板安装方法：将解压后的模板目录放入“data/custom_public/templates”目录，等待约10秒后刷新页面。
  另外你也可以直接输入模板URL使用在线模板</p>
<p>注意：修改自定义模板设置后，OBS中的自定义CSS将默认不再生效，除非特殊设置</p>
<p><a target="_blank" href="https://github.com/xfgryujk/blivechat/wiki/%E8%87%AA%E5%AE%9A%E4%B9%89HTML%E6%A8%A1%E6%9D%BF">模板开发文档</a></p>
`,
    templateDefaultTitle: '默认',
    templateDefaultDescription: '仿YouTube风格的模板，可通过自定义CSS修改样式。如不了解自定义HTML模板功能，请选择此项，否则OBS中的自定义CSS不会生效',
    templateCustomUrlTitle: '输入模板URL',
    templateCustomUrlDescription: '未列出的模板也可在此手动输入作者提供的URL',
    author: '作者：',

    urlTooLong: '房间URL过长，直播姬可能会截断（OBS无此问题）',
    roomUrlUpdated: '房间URL已更新，记得重新复制',
    roomUrl: '房间URL',
    enterRoom: '进入房间',
    copyTestRoomUrl: '复制测试房间URL',
    exportConfig: '导出配置',
    importConfig: '导入配置',

    failedToParseConfig: '配置解析失败：'
  },
  stylegen: {
    legacy: '经典',
    lineLike: '仿微信',

    playAnimation: '生成消息',
    messageSpeed: '每秒消息数',
    messageTypes: '消息类型',
    typeText: '文字',
    typeEmoticon: '表情',
    typeGift: '礼物',
    typeSuperChat: '醒目留言',
    typeMember: '新舰长',

    light: '浅色',
    dark: '深色',

    global: '全局',
    scalingNotice: '如果觉得字体太小，请优先调整此比例，而不要在OBS中拉伸浏览器源。求求你们不要拉伸然后问为什么看不清了😭',
    globalScale: '全局缩放比例',
    fontScale: '字体缩放比例',

    outlines: '描边',
    showOutlines: '显示描边',
    outlineSize: '描边尺寸',
    outlineColor: '描边颜色',
    blurryOutline: '模糊',

    avatars: '头像',
    showAvatars: '显示头像',
    avatarSize: '头像尺寸',

    userNames: '用户名',
    showUserNames: '显示用户名',
    font: '字体',
    fontSelectTip: '你也可以输入本地字体名。排在前面的字体会被优先使用',
    recentFonts: '最近使用的字体',
    presetFonts: '预设字体',
    networkFonts: '网络字体',
    localFonts: '本地字体',
    fontSize: '字体尺寸',
    fontWeight: '字体粗细',
    normalColor: '普通颜色',
    ownerColor: '主播颜色',
    moderatorColor: '房管颜色',
    memberColor: '舰长颜色',
    showBadges: '显示勋章',
    showColon: '用户名后显示冒号',
    emoticonSize: '表情大小',
    largeEmoticonSize: '大表情大小',

    messages: '消息',
    color: '颜色',
    onNewLine: '在新行显示',
    messageReverseScroll: '反向滚动',

    time: '时间',
    showTime: '显示时间',

    backgrounds: '背景',
    bgColor: '背景色',
    useBarsInsteadOfBg: '用装饰条而非背景',
    showLargeEmoticonBg: '显示大表情背景',
    messageBgColor: '消息背景色',
    ownerMessageBgColor: '主播消息背景色',
    moderatorMessageBgColor: '房管消息背景色',
    memberMessageBgColor: '舰长消息背景色',

    scAndNewMember: '付费消息',
    firstLineFont: '第一行字体',
    firstLineFontSize: '第一行字体尺寸',
    firstLineWeight: '第一行字体粗细',
    firstLineColor: '第一行颜色',
    secondLineFont: '第二行字体',
    secondLineFontSize: '第二行字体尺寸',
    secondLineWeight: '第二行字体粗细',
    secondLineColor: '第二行颜色',
    scContentLineFont: 'Super Chat内容字体',
    scContentLineFontSize: 'Super Chat内容字体尺寸',
    scContentWeight: 'Super Chat内容字体粗细',
    scContentLineColor: 'Super Chat内容颜色',
    showScTicker: '显示Super Chat固定栏',
    showOtherThings: '显示Super Chat固定栏之外的内容',

    animation: '动画',
    animateIn: '进入动画',
    fadeInTime: '淡入时间（毫秒）',
    animateOut: '旧消息退场',
    animateOutWaitTime: '退场前等待时间（秒）',
    fadeOutTime: '淡出时间（毫秒）',
    slide: '滑动',
    reverseSlide: '反向滑动',

    result: '结果CSS',
    copy: '复制',
    editor: '在线开发环境',
    resetConfig: '恢复默认设置'
  },
  help: {
    help: '帮助',
    p1_1: '1. 从这个页面复制身份码：',
    p1_2: '。注意：请勿随意刷新身份码，除非已泄露，因为刷新会使旧身份码失效',
    p2: '2. 把身份码输入到首页的房间配置，复制房间URL',
    p3: '3. 使用样式生成器生成样式，复制CSS',
    p4: '4. 在OBS中添加浏览器源',
    p5: '5. URL处输入之前复制的房间URL，自定义CSS处输入之前复制的CSS'
  },
  room: {
    fatalErrorOccurred: '发生了致命错误，请刷新页面以重新连接'
  },
  chat: {
    moderator: '管理员',
    guardLevel1: '总督',
    guardLevel2: '提督',
    guardLevel3: '舰长',
    mirrorMsg: '[跨房] ',
    sendGift: '赠送 {giftName}x{num}',
    membershipTitle: '新会员',
    tickerMembership: '会员'
  },
  plugins: {
    plugins: '插件',
    help: '帮助',
    helpContent: `\
<p>插件可以为blivechat添加更多功能，如消息日志、语音播报、点歌等。插件可能由第三方作者开发，其安全性和质量由插件作者负责。
  你可以在<a target="_blank" href="https://github.com/xfgryujk/blivechat/discussions/categories/%E6%8F%92%E4%BB%B6"
  >GitHub Discussions</a>获取已发布的插件</p>
<p>插件安装方法：将解压后的插件目录放入“data/plugins”目录，然后重启blivechat</p>
<p>注意：大部分插件需要开启“通过服务器转发消息”，并连接到房间，才能接收消息</p>
<p><a target="_blank" href="https://www.bilibili.com/video/BV1nZ42187TX/">介绍视频</a></p>
<p><a target="_blank" href="https://github.com/xfgryujk/blivechat/wiki/%E6%8F%92%E4%BB%B6%E7%B3%BB%E7%BB%9F">插件开发文档</a></p>
`,
    author: '作者：',
    disabledByServer: '已被服务器禁用',
    admin: '管理',
    connected: '已连接',
    unconnected: '未连接',
  },
}
